<template>
  <div>
    <el-form ref="form" class="props-items" :model="form" label-width="12%" v-if="propsUI.length">
      <template v-for="(ui, uiIndex) in propsUI">
        <span :key="ui.name">
          <div v-if="uiIndex === 0" style="margin: 10px 20px">重要属性:</div>
          <div v-if="ui.firstNoRequired" style="margin: 10px 20px"><el-divider></el-divider>其他属性:</div>

          <el-form-item
            v-if="ui.isShowFn ? ui.isShowFn(form) : true"
            class="cat-form-item"
            :class="{ 'material-item': ui.name === 'material_prop_149422948' }"
            :key="ui.name"
            :label="ui.label"
            :prop="ui.name"
            :rules="ui.rules"
            label-width="130px"
          >
            <component
              :ref="ui.name"
              :ui="ui"
              :is="ui.component.component"
              :props="ui.component.props"
              :value="form[ui.name]"
              @change="v => (form[ui.name] = v)"
              :form="form"
            ></component>
          </el-form-item>
        </span>
      </template>
    </el-form>
    <span v-else>无</span>
  </div>
</template>
  
<script>
import { step3FormUI } from './components/ShelvesFlow/utils/ui';
import { step3Form2Data, getValueDisplayName } from './components/ShelvesFlow/utils/data';

import { getStep3Schema } from '@/servers/prod/center/tm.js';
export default {
  model: {
    prop: 'values',
    event: 'change',
  },
  props: {
    values: {
      required: true,
    },
    categoryIds: {
      type: Array,
      default() {
        return [];
      },
    },
    baseItemId: '',
    shopId: '',
  },
  data() {
    return {
      form: {},
      propsUI: [],
    };
  },
  computed: {},
  watch: {
    categoryIds: {
      handler(v) {
        if (v?.length) {
          this.getSchema();
        }
      },
      immediate: true,
      deep: true,
    },
    shopId: {
      handler(v) {
        if (v) {
          this.getSchema();
        }
      },
    },
    form: {
      handler(v) {
        let fieldDescriptorList = step3Form2Data(this.form, this.propsUI);
        fieldDescriptorList = fieldDescriptorList.filter(item => {
          const itemUi = this.propsUI.find(ui => ui.name === item.name);
          if ((item.defaultValue !== undefined || item?.children?.length) && itemUi) {
            const valueDisplayName = getValueDisplayName(itemUi, item);
            item.label = itemUi.label;
            if (valueDisplayName) {
              item.valueDisplayName = valueDisplayName;
            }
            return true;
          }
          return false;
        });
        this.$emit('change', fieldDescriptorList);
      },
      deep: true,
    },
  },
  methods: {
    async getSchema() {
      const categoryId = this.categoryIds[this.categoryIds.length - 1];
      const shopId = this.shopId || this.$store.getters.shops_getCategoryPropShopId('tm');
      if (!categoryId || !shopId) return;
      const schema = await getStep3Schema(
        {
          companyId: this.$store.getters.userInfo.companyId,
          categoryId,
          baseItemId: this.baseItemId,
        },
        '/tm/getItemPublishSchemaByCompanyId'
      );
      const oriDatas = [
        {
          fieldDescriptorList: this.values,
        },
      ];

      const [ui, form] = step3FormUI.call(this, schema, oriDatas);
      const material_prop = ui.others.find(o => o.name === 'material_prop_149422948');
      this.propsUI = ui.props;
      if (material_prop) {
        this.propsUI.push(material_prop);
      }
      this.form = form;
      this.$nextTick(() => {
        this.validate();
      });
    },

    validate() {
      return new Promise(resolve => {
        if (this.$refs.form) {
          this.$refs.form.validate(valid => {
            resolve(valid);
          });
        } else {
          this.$message.error('当前商品分类无类目属性');
          resolve(false);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.props-items {
  padding: 20px 10px;

  & ::v-deep .cat-form-item {
    display: inline-block;
    width: 50%;
    vertical-align: top;
    margin-top: 20px;
  }
  & ::v-deep .cat-form-item.material-item {
    margin-left: -130px;
    width: 100%;
    .el-form-item__label {
      width: 120px !important;
    }
  }

  & ::v-deep .el-select {
    width: 100%;
    .el-select__tags {
      max-width: none !important;
    }
  }
}
</style>
